import { localize, setLocale } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import sl from '@vee-validate/i18n/dist/locale/sl.json'
import { email, max, min, required } from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

import i18n from '@/libs/i18n'

// setValidationLocale keeps vee-validate's own message catalog in step with the
// console UI language. Without it the validation messages stayed on the library
// default (English) forever — a Slovenian console still answered "The reply field
// is required". Called on startup and from the app store on every locale change.
export const setValidationLocale = (locale: string) => {
    setLocale(locale === 'sl' ? 'sl' : 'en')
}

export const setupVeeValidate = () => {
    defineRule('required', required)
    defineRule('email', email)
    defineRule('min', min)
    defineRule('max', max)

    configure({
        generateMessage: localize({ sl, en }),
    })

    setValidationLocale((i18n.global.locale as unknown as { value: string }).value)
}
